import { FenixA320MarketingSeo } from "../../../content/templateMarketing/fenix-a320-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fenixA320Image from "../../images/templates/fenix-a320.png";

export const fenixA320Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "Fenix A320",
  id: "fenix-a320",
  platforms: ["msfs"],
  image: fenixA320Image,
  infoMarketingBlurb: FenixA320MarketingSeo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Power Up & Overhead Panel",
        },
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Battery 1 & 2",
          setting: "On",
        },
        {
          item: "External Power",
          setting: "As Req / On",
        },
        {
          item: "Nav & Logo Lights",
          setting: "On",
        },
        {
          item: "APU",
          setting: "Start",
        },
        {
          item: "External Power",
          setting: "Off",
        },
        {
          item: "APU Bleed",
          setting: "On",
        },
        {
          item: "ADIRS",
          setting: "Nav",
        },
        {
          item: "Fuel Pumps",
          setting: "On",
        },
        {
          item: "Oxygen Crew Supply",
          setting: "On",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Arm",
        },
        {
          item: "Overhead Panel",
          setting: "Check",
        },
        {
          item: "No Smoking",
          setting: "Auto",
        },
        {
          header: "Glare Shield, Main Panel & Pedestal",
        },
        {
          item: "Altimeter/Baro Ref (EFIS & STBY)",
          setting: "Set Local",
        },
        {
          item: "FD Button",
          setting: "Check On",
        },
        {
          item: "EFIS Modes & Lighting",
          setting: "As Req",
        },
        {
          item: "FCU SPD",
          setting: "Check Dashed",
        },
        {
          item: "FCU HDG",
          setting: "Check Dashed",
        },
        {
          item: "FCU ALT SEL",
          setting: "Set Altitude",
        },
        {
          item: "Weather Radar",
          setting: "Check Off",
        },
        {
          item: "Transponder/TCAS",
          setting: "Set / Auto & Stby",
        },
      ],
    },
    {
      title: "Pushback & Engine Start",
      roles: ["beforePushback", "beforeEngineStart", "beforeFlightStart", "engineStart"],
      content: [
        {
          header: "Before Pushback",
        },
        {
          item: "Parking Brake",
          setting: "Verify Set",
        },
        {
          item: "Windows",
          setting: "Closed",
        },
        {
          item: "External Power",
          setting: "Verify Off",
        },
        {
          item: "APU Bleed",
          setting: "Verify On",
        },
        {
          item: "Seatbelt Signs",
          setting: "On",
        },
        {
          header: "Pushback",
        },
        {
          item: "Beacon",
          setting: "On",
        },
        {
          item: "ENG Mode Selector",
          setting: "Ign/Start",
        },
        {
          item: "ENG 2 Master Switch",
          setting: "On",
        },
        {
          item: "ENG 2 Parameters",
          setting: "Monitor",
        },
        {
          item: "ENG 1 Master Switch",
          setting: "On",
        },
        {
          item: "ENG 1 Parameters",
          setting: "Monitor",
        },
      ],
    },
    {
      title: "After Start & Before Taxi",
      roles: ["afterEngineStart", "beforeTaxi", "taxi"],
      content: [
        {
          item: "ENG Mode Selector",
          setting: "As Req / Norm",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "APU Master",
          setting: "Off",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "Auto Brake",
          setting: "Max",
        },
        {
          item: "Flaps",
          setting: "Set For Takeoff",
        },
        {
          item: "Ground Spoilers",
          setting: "Arm",
        },
        {
          item: "Rudder & Aileron Trim",
          setting: "Zero",
        },
        {
          item: "Pitch Trim",
          setting: "As Calculated",
        },
        {
          item: "Flight Controls",
          setting: "Free & Full Movement",
        },
        {
          item: "ATC Clearance",
          setting: "As Req",
        },
        {
          item: "Strobes",
          setting: "Auto",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Req / On (at night)",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        {
          item: "Terrain on ND",
          setting: "As Req",
        },
        {
          item: "Weather Radar",
          setting: "On",
        },
        {
          item: "Predictive Windshear",
          setting: "On",
        },
        {
          item: "Transponder/TCAS",
          setting: "TA/RA",
        },
        {
          item: "TO Config Test",
          setting: "Push",
        },
        {
          item: "Pack 1 & 2",
          setting: "As Req",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "ENG Mode Selector",
          setting: "As Req",
        },
        {
          item: "Nose Light",
          setting: "Takeoff",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Strobe Lights",
          setting: "On",
        },
      ],
    },
    {
      title: "After Takeoff",
      roles: ["climbOut"],
      content: [
        {
          item: "Landing Gear",
          setting: "Verify Up",
        },
        {
          item: "Flaps",
          setting: "Verify Retracted",
        },
        {
          item: "Ground Spoilers",
          setting: "Disarm",
        },
        {
          item: "Pack 1 & 2",
          setting: "On",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "ENG Mode Selector",
          setting: "As Req",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "Off & Retract",
        },
        {
          item: "Nose Light",
          setting: "Off",
        },
        {
          item: "Terrain On ND",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimiter",
          setting: "Set STD",
        },
      ],
    },
    "page-break",
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        {
          item: "Seatbelt Signs",
          setting: "Off",
        },
        {
          item: "FMAs",
          setting: "Check",
        },
        {
          item: "Pressurization",
          setting: "Check",
        },
        {
          item: "Flight Plan",
          setting: "Monitor",
        },
        {
          item: "Top of Descent",
          setting: "Cross Check",
        },
      ],
    },
    {
      title: "Descent",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Autobrake",
          setting: "As Req",
        },
        {
          item: "Passenger Signs",
          setting: "As Req",
        },
        {
          item: "FCU Alt Select",
          setting: "Set",
        },
        {
          header: "Top of Descent",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "ENG Mode Selector",
          setting: "As Req",
        },
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimeter",
          setting: "Set Local",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Terrain On ND",
          setting: "As Req",
        },
        {
          item: "Passenger Signs",
          setting: "On",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "landing"],
      content: [
        {
          header: "Cleared for Approach",
        },
        {
          item: "LS Button",
          setting: "On",
        },
        {
          item: "Autobrake",
          setting: "Check Set",
        },
        {
          item: "Ground Spoilers",
          setting: "Arm",
        },
        {
          item: "Altimeters",
          setting: "Verify Local",
        },
        {
          item: "Engine & Wing Anti-Ice",
          setting: "As Req",
        },
        {
          item: "ENG Mode Selector",
          setting: "As Req",
        },
        {
          header: "Before Landing",
        },
        {
          item: "Auto Brakes",
          setting: "Verify Set",
        },
        {
          item: "Ground Spoilers",
          setting: "Verify Arm",
        },
        {
          item: "Landing Gear",
          setting: "Verify Down & Green",
        },
        {
          item: "Flaps",
          setting: "Verify Set",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Strobe Lights",
          setting: "Off",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Req / On (at night)",
        },
        {
          item: "Flaps",
          setting: "Retract",
        },
        {
          item: "Ground Spoilers",
          setting: "Retract",
        },
        {
          item: "Terrain On ND",
          setting: "Off",
        },
        {
          item: "Weather Radar",
          setting: "Off",
        },
        {
          item: "Pred. Windshear",
          setting: "Off",
        },
        {
          item: "Transponder / TCAS",
          setting: "Stby",
        },
        {
          item: "APU",
          setting: "As Req / Start",
        },
        {
          item: "Anti-Ice",
          setting: "As Req",
        },
      ],
    },
    {
      title: "Parking / Gate",
      roles: ["parking", "shutdown", "securing"],
      content: [
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Nose Lights",
          setting: "Off",
        },
        {
          item: "Anti-Ice",
          setting: "Off",
        },
        {
          item: "APU Bleed",
          setting: "On",
        },
        {
          item: "Elapsed Timer",
          setting: "Stop",
        },
        {
          item: "Engine Master 1 & 2",
          setting: "Off",
        },
        {
          item: "Seatbelt Signs",
          setting: "Off",
        },
        {
          item: "Beacon",
          setting: "Off",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Transponder / TCAS",
          setting: "Off",
        },
      ],
    },
  ],
};
